import { render } from "./PlanOne.vue?vue&type=template&id=58584ac4&scoped=true"
import script from "./PlanOne.vue?vue&type=script&lang=js"
export * from "./PlanOne.vue?vue&type=script&lang=js"

import "./PlanOne.vue?vue&type=style&index=0&id=58584ac4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58584ac4"]])

export default __exports__